import './Empty.css';

import { IonCol, IonIcon, IonRow, IonText } from '@ionic/react';

interface EmptyProps {
    text: string,
    icon: any,
    length: number
}

export const Empty: React.FC<EmptyProps> = (props) => {
    return props.length == 0 ?
        <div className="empty">
            <div>
                <IonRow>
                    <IonCol size="12">
                        <IonIcon icon={props.icon} />
                    </IonCol>
                    <IonCol size="12">
                        <IonText>{props.text}</IonText>
                    </IonCol>
                </IonRow>
            </div>
        </div>
        : <>{props.children}</>;
}